<template>
  <div class="ExtraWorkGroupRequest">
    <box v-if="step === 1" :title="$t('choosePersonel')" class="">
      <div class="pa-3">
        <div class="mt-2">
          <v-btn
            rounded
            small
            outlined
            color="primary"
            class="ml-2"
            @click="selectAll"
            >{{ $t("selectAll") }}</v-btn
          >
          <v-btn rounded small outlined color="primary" @click="deselectAll">{{
            $t("deselectAll")
          }}</v-btn>
        </div>
        <v-row>
          <v-col sm="4" v-for="(item, index) in personelList" :key="index">
            <v-checkbox
              multiple
              hide-details
              :value="item"
              :label="item.PersonName"
              v-model="selectedPerson"
              :disabled="item.PerNo.trim() == managerPerno"
            />
          </v-col>
        </v-row>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="step = 2" color="primary">{{ $t("submitPage") }}</v-btn>
      </v-card-actions>
    </box>

    <box v-if="step === 2" :title="$t('submitPage')" class="">
      <template slot="top-action-view">
        <v-btn rounded small outlined dark @click="step = 1"
          >{{ $t("choosePersonel") }}
          <v-icon class="mr-2" small> mdi-chevron-left</v-icon>
        </v-btn>
      </template>
      <div class="px-3 pt-2">
        <v-form ref="form" v-model="form">
          <table>
            <tbody>
              <tr>
                <td>
                  <label>{{ $t("fromDate") }} : </label>
                </td>
                <td>
                  <div>
                    <dialog-date-picker
                      :label="$t('fromDate') + ':'"
                      :initDate="initBeginDate"
                      @dateResult="bDate"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("toDate") }} : </label>
                </td>
                <td>
                  <div>
                    <dialog-date-picker
                      :label="$t('toDate') + ':'"
                      :initDate="initEndDate"
                      @dateResult="eDate"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("fromTime") }} : </label>
                </td>
                <td>
                  <div>
                    <dialog-time-picker
                      :label="$t('fromTime') + ':'"
                      :initTime="initBeginTime"
                      @dateResult="bTime"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <label>{{ $t("toTime") }} : </label>
                </td>
                <td>
                  <div>
                    <dialog-time-picker
                      :label="$t('toTime') + ':'"
                      :initTime="initEndTime"
                      @dateResult="eTime"
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td>{{ $t("description") }}:</td>
                <td>
                  <v-textarea
                    ref="description"
                    class="mt-1"
                    v-model="eworkParams.Description"
                    auto-grow
                    :label="$t('description')"
                    rows="1"
                  ></v-textarea>
                </td>
              </tr>
            </tbody>
          </table>
        </v-form>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!form"
          :loading="isLoading"
          @click="submit"
          color="primary"
          >{{ $t("submit") }}</v-btn
        >
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import DialogDatePicker from "../../components/widget/DialogDatePicker.vue";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";
import ResultType from "../../model/ResultType";
import DateUtils from "../../utils/DateUtils";
export default {
  components: { DialogTimePicker, DialogDatePicker },
  data() {
    return {
      step: 1,
      personelList: [],
      selectedPerson: [],
      eworkParams: {},
      form: false,
      isLoading: false,
      initBeginDate: null,
      initBeginTime: null,
      beginDate: "",
      initEndDate: null,
      initEndTime: null,
      endDate: "",
      beginTime: "",
      endTime: "",
    };
  },
  computed:{
    managerPerno(){
      return this.$store.state.auth.auth.username 
    }
  },
  mounted() {
    this.getPersonelList();
  },
  methods: {
    getArgs() {
      ////console.log(this.$route.params);
      let details = this.$route.params.details;
      if (details) {
        this.loadRegistration(details);
      }
    },
    loadRegistration(details) {
      //console.log(details);
      var selected = this.personelList.filter((item) =>
        details.personelsPerno.includes(item.PerNo)
      );
      this.selectedPerson = selected;
      this.eworkParams.pageNo = details.pageno.toString().trim();
      this.eworkParams.Description = details.userDescription;

      this.initBeginDate = this.beginDate = details.beginDate;
      this.initEndDate = this.endDate = details.endDate;
      this.initBeginTime = this.beginTime = details.beginTime;
      this.initEndTime = this.endTime = details.endTime;
    },
    getPersonelList() {
      var permissionNumber = 52;
      this.$store
        .dispatch("GetAccessPersonList", { permissionNumber })
        .then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            this.personelList = result.data;
          }
          this.getArgs();
        });
    },
    selectAll() {
      this.selectedPerson.splice(0);
      if (this.personelList && this.personelList.length > 0) {
        this.selectedPerson.push(
          ...this.personelList.filter(p=> p.PerNo.trim() != this.managerPerno)
        ); /*.map((item) => item.PerNo);*/
      }
    },
    deselectAll() {
      if (this.selectedPerson && this.selectedPerson.length > 0) {
        this.selectedPerson.splice(0);
      }
    },
    bDate(date) {
      this.beginDate = date;
    },
    eDate(date) {
      this.endDate = date;
    },
    bTime(date) {
      this.beginTime = date;
    },
    eTime(date) {
      this.endTime = date;
    },
    submit() {
      //empty date
      if (!this.beginDate || !this.endDate) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.wrongDate"),
        });
        return;
      }

      //empty time
      if (!this.beginTime || !this.endTime) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.wrongTime"),
        });
        return;
      }

      //dateMustbeinSameYear
      if (this.beginDate.substr(0, 4) != this.endDate.substr(0, 4)) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.dateMustbeinSameYear"),
        });
        return;
      }

      //CompareDates
      if (DateUtils.CompareDates(this.beginDate, this.endDate) != 1) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.CompareDates"),
        });
        return;
      }

      //CompareTimes
      if (
        this.beginDate + " " + this.beginTime >=
        this.endDate + " " + this.endTime
      ) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: this.$t("eosWinKartWebResource.CompareTimes"),
        });
        return;
      }

      if (this.beginDate == this.endDate) {
        if (this.beginTime >= this.endTime) {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: this.$t("eosWinKartWebResource.CompareTimes"),
          });
          return;
        }
      }

      //over 24 hours
      var moment = require("jalali-moment");
      var a = moment(
        this.beginDate + "-" + this.beginTime,
        "jYYYY/jMM/jDD-hh:mm"
      ).locale("fa");

      var b = moment(
        this.endDate + "-" + this.endTime,
        "jYYYY/jMM/jDD-hh:mm"
      ).locale("fa");

      var diff = b.diff(a, "hours");
      if (diff > 24) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "مدت زمان اضافه کار بیش از 24 ساعت است",
        });
        return;
      }

      if (this.selectedPerson.length < 1) {
        this.$EosToast.show({
          type: EosToastType.error,
          msg: "حداقل یک پرسنل انتخاب نمایید.",
        });
        return;
      }

      var perNos = "";
      this.selectedPerson.forEach((element) => {
        perNos += element.PerNo.toString() + ";";
      });

      const params = new URLSearchParams();
      params.append("beginDate", this.beginDate);
      params.append("beginTime", this.beginTime);
      params.append("endDate", this.endDate);
      params.append("endtime", this.endTime);
      params.append("perNos", perNos); //this.selectedPerson.map((item) => item.PerNo.toString()));
      params.append(
        "perNames",
        this.selectedPerson.map((item) => item.JustName)
      );
      params.append("userDescription", this.eworkParams.Description || "");

      if (this.eworkParams.pageNo) {
        params.append("pageNo", this.eworkParams.pageNo);

        this.$store.dispatch("UpdateExtraWork", { params }).then((result) => {
          if (result.type === "success") {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("msg-registration-success", {
                opName: this.$t("nav-request-extra-work"),
              }),
            });

            this.$refs.form.reset();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        });
      } else {
        this.$store.dispatch("InsertExtraWork", { params }).then((result) => {
          if (result.type === "success") {
            this.$EosToast.show({
              type: EosToastType.success,
              msg: this.$t("msg-registration-success", {
                opName: this.$t("nav-request-extra-work"),
              }),
            });
            this.$refs.form.reset();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        });
      }
    },
  },
};
</script>

<style>
</style>